var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOctopus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 491 487",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: -76.114,
    cy: 525.03,
    r: 454.6,
    gradientTransform: "matrix(.35624 -.5997 .62718 .37256 -439.32 -34.604)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#faa",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fb7d7d",
    stopOpacity: 0.12169,
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: -76.114,
    cy: 525.03,
    r: 454.6,
    gradientTransform: "matrix(.35624 -.5997 .62718 .37256 -441.99 -30.671)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#faa",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fb7d7d",
    stopOpacity: 0.12169,
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 225.49,
    cy: 345.81,
    r: 38.553,
    gradientTransform: "translate(75.528 18.04)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    label: "Ebene 1"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m425.71 192.36c-43.232 32.797-83.345 139.53-120.26 177.6-41.873 52.797-87.787 114.1-80.455 185.46 38.983 126.41 56.068 110.61 54.994 152.26 37.509 182.38 112.48 188.9 127.41 285.36 15.429 30.735 0.81589 68.488-31.727 80.507-13.612 8.1983-44.092 12.648-49.446 13.904 48.643 16.528 93.246-27.433 106.97-70.789 40.73-108.83-79.43-192.51-91.48-262.09 32.66-118.99-91.8-151.23-14.44-308.37 20.421-32.795 56.25-56.272 86.872-34.182 33.234 20.154 68.102 52.087 110.2 40.007 9.3631-1.443 92.78-75.719 101.37-79.703",
    fill: "#ff8080",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m497.14 152.36c-82.616 49.842-169.36 24.371-261.4-3.8459-224.41 5.8834-268.32 234.43-343.32 432.24 31.662 295.9-95.889 482.64-169.36 432.36 15.546 11.87 53.394 32.228 83.102 13.948 75.558-86.318 111.26-201.34 123.3-313.67 4.4064-181.43 134.61-586.27 354.91-447.83 43.596 79.688 168.41 21.548 245-9.2818 30.657-10.398 39.823 40.927 67.755 24.652",
    fill: "#ff8080",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m514.29 32.362c-11.91 152.91-214.82 118.6-325.38 89.958-130.43-49.801-261.6 105.95-412.07 4.67-101.26-129.64-21.72-294.63 91.81-167.99 110.51 40.42 212.51-220.49 109.46-67.71-157.46 132.05-87.67-111.17-256.88 1.78-57.884 108.06-50.974 280.57 71.505 328.43 131.1 50.628 262.84-90.872 386.55 4.3933 101.37 80.735 223.09 41.954 337.82 27.71 25.988-3.7064 51.899-8.3704 77.182-15.524",
    fill: "#f55",
    stroke: "url(#e)",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m348.57 312.36c-75.39 81.37-178.24 103.59-306.48 173.05-117.03 38.77-218.09 16.75-352.54 100.06-89.478 119.82-277.33 193.31-346.12 82.684 26.898 69.122 84.887 95.186 149.8 81.509 76.454-9.5669 138.58-58.044 201.82-97.479 77.726-42.992 170.82-77.224 260.03-66.117 127.23-25.82 224.16-121.95 357.41-126.73 90.828-11.699 170.07-60.896 250.31-100.81 5.6649-1.4341 11.451-2.2759 17.197-3.2998",
    fill: "#f55",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m771.43 349.51c-16.3 111.29-52.47 168.51-140.35 251.8-74.711 73.524-289.33 304.57-186.6 358.58 39.83 26.822 99.164 59.543 154.4 78.02 87.488 67.643 2.5246 166.04-43.417 222.34-17.316 13.792-46.413 51.925-64.844 41.009 47.958-55.783 93.893-107.38 106.9-171.43 12.986-41.395-40.322-81.029-81.38-84.11-56.33-18.3-121.66-39.2-137.95-110.96-13.09-205.99 121.52-275.58 192.98-369.65 40.236-42.226 67.301-96.058 80.262-152.73",
    fill: "#ff2a2a",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m480 332.36c17.542 77.699-31.486 136.65-99.36 193.99-123.22 82.033-235.79 85.922-173.64 330.47 25.523 47.266 70.244 175.18 40.529 236.63-19.943 58.702-42.963 106.16-41.412 191.19 33.602 204.49-25.778-34.267 71.987-178.65 55.362-211.37-81.9-286.9-25.412-379.43 7.9754-63.705 102.47-104.47 167.78-152.21 44.331-24.538 106.59-143.14 151.13-67.455-9.4061 92.727 11.607 210.69 67.069 280.93 125.55 196.12-163.32 245.12-213.66 380.33-24.728 47.6-53.573 111.04-36.606 151.11 3.9608-96.59 87.774-161.05 157.35-216.33 130.62-80.05 204.23-208.11 162.07-343.85-28.217-64.566-83.751-128.15-71.325-207.37 13.808-49.073 60.655-85.715 60.646-139.33",
    fill: "#f55",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m774.29 386.65c26.837 155.53 127.06 286.52 243.88 387.28 90.998 128.11 53.144 180.93 33.199 272.69-47.626 111.1-121.51 190.88-138.98 331.27-14.709 35.847-11.399 119.84-16.673 32.878 3.3848-206.34 34.435-181.01 66.276-267.06 41.724-87.122 80.951-190.78 43.971-284.37-52.93-89.89-164.01-134.56-210.63-244.41-69.77-58.26-126.8-137.18-118.76-232.73-0.20795-12.798 0.0287-25.599 0.53228-38.387",
    fill: "#ff2a2a",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m914.29 343.79c-127.77 34.08-93.797 180.99-40.316 261.63 74.684 277.25-78.215 198.01-75.747 613.31 25.378 168.85-31.905 269.17-166.75 233.89-148.52-26.948 170.21 57.104 141.96-125.11 1.1767-138.72-57.101-249.58 2.3476-424.65 65.53-102.82 65.93-227.58 14.23-333.42-35.96-70.74-99.84-112.05-130.02-185.62",
    fill: "#f55",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m582.86 383.79c62.83 37.076 62.001 119.79 103.29 173.52 87.825 99.139 255.09 139.2 369.48 133.25 99.905 7.4368 157.66 112.87 69.356 178.02 151.5-81.705 9.3039-249.24-117.74-238.46-68.556-5.9608-136.98-22.689-199.51-51.257-69.632-40.984-137.4-113.22-126.37-200.17 2.1937-10.776 2.6343-23.274 10.065-32.05",
    fill: "#f55",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m511.43 255.22l-48.571-8.5714c7.619 12.181 15.238 16.832 22.857 42.857-4.7778-19.022-34.788 2.328-57.143 11.429 19.048 9.4345 38.095 31.95 57.143 17.143-9.6144 11.982-17.686 24.272-8.5714 40 10.476-0.14359 20.952 17.643 31.429-2.8572l2.8571 37.143c23.908 2.7456 35.088-4.6916 40-17.143 15.874 3.8077 22.198 21.941 22.857 48.571 9.5317-12.365 22.759-17.339 28.571-37.143 8.4591 22.803 19.163 27.65 31.429 20 11.768-11.848 19.439-24.379 8.5714-40l-37.143-74.286-94.286-37.142z",
    fill: "#773737",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m511.43 28.648c-50.12-288.11 231.97-605.76 597.17-457.14 338.22 150.74 264.39 384.36 240 534.29-197.9 444.51-477.09 248.42-477.14 251.43-214.04 36.133-414.18 52.537-360-328.57l-0.03-0.01z",
    fill: "#f55",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m542.67 179.86c-108.34 83.255-310.26 79.121-396.81 1.383-70.295 7.0791-160.11-58.625 36.088 40.717 71.231 80.735 222.37 41.954 337.82 27.71 25.988-3.7064-28.101-31.227-2.8176-38.381",
    fill: "#ff2a2a",
    stroke: "url(#d)",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m1363.7-133.85c-68.113 315.53-94.167 464.76-423.6 502.61-51.919-1.8274-79.021-12.903-13.112 15.54 218.71 100.72 454.81-207.55 447.01-423.07 0.8095-70.287-0.9503-88.478-10.254-95.076l-0.044-4e-3z",
    fill: "#d40000",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m1155.8 15.692c-7.9883 8.7455-12.906 20.663-12.906 33.812 0 26.825 20.471 48.562 45.719 48.562 25.247 0 45.688-21.737 45.688-48.562 0-10.05-2.8609-19.377-7.7812-27.125 1.3363 4.9268 2.0937 10.191 2.0937 15.688 0 26.825-17.291 48.594-38.594 48.594-21.302 0-38.562-21.768-38.562-48.594 0-8.0704 1.578-15.678 4.3437-22.375h-0.0012z",
    fill: "#faa",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m710-36.196c-21.304 0-38.58 15.339-38.58 34.272s17.277 34.272 38.58 34.272c21.304 0 38.58-15.339 38.58-34.272s-17.277-34.272-38.58-34.272zm1.0782 7.3976c14.794 0 26.767 11.615 26.767 25.942 0 14.328-11.973 25.942-26.767 25.942s-26.791-11.615-26.791-25.942c0-14.328 11.996-25.942 26.791-25.942z",
    fill: "#faa",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m584.29 29.518c-14.204 0-25.723 12.782-25.723 28.558s11.519 28.558 25.723 28.558 25.723-12.782 25.723-28.558-11.519-28.558-25.723-28.558zm0.71887 6.1642c9.8639 0 17.847 9.6782 17.847 21.617s-7.9829 21.617-17.847 21.617c-9.864 0-17.862-9.6782-17.862-21.617s7.9985-21.617 17.862-21.617z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m674.29 66.661c-13.415 0-24.295 9.5849-24.295 21.415s10.879 21.415 24.295 21.415c13.415 0 24.295-9.5849 24.295-21.415s-10.879-21.415-24.295-21.415zm0.67895 4.6224c9.3161 0 16.856 7.2575 16.856 16.21 0 8.9526-7.5396 16.21-16.856 16.21-9.3161 0-16.87-7.2575-16.87-16.21 0-8.9526 7.5543-16.21 16.87-16.21z",
    fill: "#faa",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m591.43-104.77c-21.304 0-38.58 15.339-38.58 34.272s17.277 34.272 38.58 34.272c21.304 0 38.58-15.339 38.58-34.272s-17.277-34.272-38.58-34.272zm1.0782 7.3976c14.794 0 26.767 11.615 26.767 25.942 0 14.328-11.973 25.942-26.767 25.942s-26.791-11.615-26.791-25.942c0-14.328 11.996-25.942 26.791-25.942z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m742.86 126.66c-10.26 0-18.58 7.6667-18.58 17.129 0 9.4627 8.3205 17.129 18.58 17.129s18.58-7.6667 18.58-17.129c0-9.4627-8.3205-17.129-18.58-17.129zm0.51925 3.6974c7.1249 0 12.891 5.8051 12.891 12.966 0 7.161-5.7662 12.966-12.891 12.966-7.1249 0-12.902-5.8051-12.902-12.966 0-7.161 5.7775-12.966 12.902-12.966z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m571.43 115.23c-8.6822 0-15.723 6.3879-15.723 14.272 0 7.8844 7.041 14.272 15.723 14.272 8.6822 0 15.723-6.3879 15.723-14.272 0-7.8844-7.041-14.272-15.723-14.272zm0.43941 3.0807c6.0293 0 10.909 4.8369 10.909 10.803 0 5.9666-4.8795 10.803-10.909 10.803-6.0293 0-10.918-4.8368-10.918-10.803 0-5.9666 4.8891-10.803 10.918-10.803z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m617.14 158.09c-8.6822 0-15.723 6.3879-15.723 14.272 0 7.8844 7.041 14.272 15.723 14.272 8.6822 0 15.723-6.3879 15.723-14.272 0-7.8844-7.041-14.272-15.723-14.272zm0.43941 3.0807c6.0293 0 10.909 4.8369 10.909 10.803 0 5.9666-4.8795 10.803-10.909 10.803-6.0293 0-10.918-4.8368-10.918-10.803 0-5.9666 4.8891-10.803 10.918-10.803z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m1020 255.23c-8.6822 0-15.723 6.3879-15.723 14.272 0 7.8844 7.0411 14.272 15.723 14.272 8.6821 0 15.723-6.3879 15.723-14.272 0-7.8844-7.0411-14.272-15.723-14.272zm0.4394 3.0807c6.0293 0 10.909 4.8369 10.909 10.803 0 5.9666-4.8795 10.803-10.909 10.803-6.0293 0-10.918-4.8368-10.918-10.803 0-5.9666 4.8891-10.803 10.918-10.803z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m1108.6 235.23c-8.6822 0-15.723 6.3879-15.723 14.272 0 7.8844 7.041 14.272 15.723 14.272 8.6822 0 15.723-6.3879 15.723-14.272 0-7.8844-7.041-14.272-15.723-14.272zm0.4394 3.0807c6.0293 0 10.909 4.8369 10.909 10.803 0 5.9666-4.8795 10.803-10.909 10.803-6.0293 0-10.918-4.8368-10.918-10.803 0-5.9666 4.8891-10.803 10.918-10.803z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m1191.4 140.95c-8.6822 0-15.723 6.3879-15.723 14.272 0 7.8844 7.041 14.272 15.723 14.272 8.6822 0 15.723-6.3879 15.723-14.272 0-7.8844-7.041-14.272-15.723-14.272zm0.4394 3.0807c6.0293 0 10.909 4.8369 10.909 10.803 0 5.9666-4.8795 10.803-10.909 10.803-6.0293 0-10.918-4.8368-10.918-10.803 0-5.9666 4.8891-10.803 10.918-10.803z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m1282.9-59.053c-8.6821 0-15.723 6.3879-15.723 14.272 0 7.8844 7.0411 14.272 15.723 14.272 8.6822 0 15.723-6.3879 15.723-14.272 0-7.8844-7.0411-14.272-15.723-14.272zm0.4395 3.0807c6.0293 0 10.909 4.8369 10.909 10.803 0 5.9666-4.8795 10.803-10.909 10.803-6.0293 0-10.918-4.8368-10.918-10.803 0-5.9666 4.8891-10.803 10.918-10.803z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m1285.7-187.62c-8.6822 0-15.723 6.3879-15.723 14.272 0 7.8844 7.041 14.272 15.723 14.272 8.6822 0 15.723-6.3879 15.723-14.272 0-7.8844-7.041-14.272-15.723-14.272zm0.4394 3.0807c6.0293 0 10.909 4.8369 10.909 10.803 0 5.9666-4.8795 10.803-10.909 10.803-6.0293 0-10.918-4.8368-10.918-10.803 0-5.9666 4.8891-10.803 10.918-10.803z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m1268.6 92.376c-8.6822 0-15.723 6.3879-15.723 14.272 0 7.8844 7.041 14.272 15.723 14.272 8.6822 0 15.723-6.3879 15.723-14.272 0-7.8844-7.041-14.272-15.723-14.272zm0.4394 3.0807c6.0293 0 10.909 4.8369 10.909 10.803 0 5.9666-4.8796 10.803-10.909 10.803-6.0293 0-10.918-4.8368-10.918-10.803 0-5.9666 4.889-10.803 10.918-10.803z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m1211.4-99.053c-8.6822 0-15.723 6.3879-15.723 14.272 0 7.8844 7.041 14.272 15.723 14.272 8.6822 0 15.723-6.3879 15.723-14.272 0-7.8844-7.041-14.272-15.723-14.272zm0.4394 3.0807c6.0293 0 10.909 4.8369 10.909 10.803 0 5.9666-4.8795 10.803-10.909 10.803-6.0293 0-10.918-4.8368-10.918-10.803 0-5.9666 4.8891-10.803 10.918-10.803z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m914.29 246.66c-21.304 0-38.58 15.339-38.58 34.272s17.277 34.272 38.58 34.272c21.304 0 38.58-15.339 38.58-34.272s-17.277-34.272-38.58-34.272zm1.0782 7.3976c14.794 0 26.767 11.615 26.767 25.942 0 14.328-11.973 25.942-26.767 25.942s-26.791-11.615-26.791-25.942c0-14.328 11.996-25.942 26.791-25.942z",
    fill: "#faa",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m785.71 59.518c-13.415 0-24.295 9.5849-24.295 21.415s10.879 21.415 24.295 21.415c13.415 0 24.295-9.5849 24.295-21.415s-10.879-21.415-24.295-21.415zm0.67895 4.6224c9.3161 0 16.856 7.2575 16.856 16.21 0 8.9526-7.5396 16.21-16.856 16.21-9.3161 0-16.87-7.2575-16.87-16.21 0-8.9526 7.5543-16.21 16.87-16.21z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m521.43-31.91c-4.738 0-8.5804 9.5849-8.5804 21.415s3.8424 21.415 8.5804 21.415 8.5804-9.5849 8.5804-21.415-3.8424-21.415-8.5804-21.415zm0.2398 4.6224c3.2903 0 5.9531 7.2575 5.9531 16.21 0 8.9526-2.6628 16.21-5.9531 16.21s-5.9583-7.2575-5.9583-16.21c0-8.9526 2.668-16.21 5.9583-16.21z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m841.43 333.8c-9.471 0-17.152 5.1092-17.152 11.415 0 6.306 7.6808 11.415 17.152 11.415 9.471 0 17.152-5.1092 17.152-11.415 0-6.306-7.6808-11.415-17.152-11.415zm0.47933 2.464c6.5771 0 11.9 3.8686 11.9 8.6407s-5.3229 8.6407-11.9 8.6407-11.91-3.8686-11.91-8.6407 5.3333-8.6407 11.91-8.6407z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m1118.6 169.52c-12.626 0-22.866 9.5849-22.866 21.415s10.24 21.415 22.866 21.415 22.866-9.5849 22.866-21.415-10.24-21.415-22.866-21.415zm0.639 4.6224c8.7683 0 15.864 7.2576 15.864 16.21 0 8.9526-7.0962 16.21-15.864 16.21-8.7684 0-15.878-7.2576-15.878-16.21 0-8.9526 7.1101-16.21 15.878-16.21z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m-291.43 69.518c-8.6822 0-15.723 6.3879-15.723 14.272 0 7.8844 7.041 14.272 15.723 14.272 8.6822 0 15.723-6.3879 15.723-14.272 0-7.8844-7.041-14.272-15.723-14.272zm0.4394 3.0807c6.0293 0 10.909 4.8369 10.909 10.803 0 5.9666-4.8795 10.803-10.909 10.803-6.0293 0-10.918-4.8368-10.918-10.803 0-5.9666 4.8891-10.803 10.918-10.803z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m-269.43 129.52c-8.6822 0-15.723 6.3879-15.723 14.272 0 7.8844 7.041 14.272 15.723 14.272 8.6822 0 15.723-6.3879 15.723-14.272 0-7.8844-7.041-14.272-15.723-14.272zm0.4394 3.0807c6.0293 0 10.909 4.8369 10.909 10.803 0 5.9666-4.8795 10.803-10.909 10.803-6.0293 0-10.918-4.8368-10.918-10.803 0-5.9666 4.8891-10.803 10.918-10.803z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m-234.29 169.52c-8.6822 0-15.723 6.3879-15.723 14.272 0 7.8844 7.041 14.272 15.723 14.272 8.6822 0 15.723-6.3879 15.723-14.272 0-7.8844-7.041-14.272-15.723-14.272zm0.4394 3.0807c6.0293 0 10.909 4.8369 10.909 10.803 0 5.9666-4.8795 10.803-10.909 10.803-6.0293 0-10.918-4.8368-10.918-10.803 0-5.9666 4.8891-10.803 10.918-10.803z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m-194.29 183.8c-8.6822 0-15.723 6.3879-15.723 14.272 0 7.8844 7.041 14.272 15.723 14.272 8.6822 0 15.723-6.3879 15.723-14.272 0-7.8844-7.041-14.272-15.723-14.272zm0.4394 3.0807c6.0293 0 10.909 4.8369 10.909 10.803 0 5.9666-4.8795 10.803-10.909 10.803-6.0293 0-10.918-4.8368-10.918-10.803 0-5.9666 4.8891-10.803 10.918-10.803z",
    fill: "#faa",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m394.29 398.09c-8.6822 0-15.723 6.3879-15.723 14.272 0 7.8844 7.041 14.272 15.723 14.272 8.6822 0 15.723-6.3879 15.723-14.272 0-7.8844-7.041-14.272-15.723-14.272zm0.4394 3.0807c6.0293 0 10.909 4.8369 10.909 10.803 0 5.9666-4.8795 10.803-10.909 10.803-6.0293 0-10.918-4.8368-10.918-10.803 0-5.9666 4.8891-10.803 10.918-10.803z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m334.29 406.66c-8.6822 0-15.723 6.3879-15.723 14.272 0 7.8844 7.041 14.272 15.723 14.272 8.6822 0 15.723-6.3879 15.723-14.272 0-7.8844-7.041-14.272-15.723-14.272zm0.4394 3.0807c6.0293 0 10.909 4.8369 10.909 10.803 0 5.9666-4.8795 10.803-10.909 10.803-6.0293 0-10.918-4.8368-10.918-10.803 0-5.9666 4.8891-10.803 10.918-10.803z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m440 369.52c-8.6822 0-15.723 6.3879-15.723 14.272 0 7.8844 7.041 14.272 15.723 14.272 8.6822 0 15.723-6.3879 15.723-14.272 0-7.8844-7.041-14.272-15.723-14.272zm0.4394 3.0807c6.0293 0 10.909 4.8369 10.909 10.803 0 5.9666-4.8795 10.803-10.909 10.803-6.0293 0-10.918-4.8368-10.918-10.803 0-5.9666 4.8891-10.803 10.918-10.803z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m271.43 432.38c-8.6822 0-15.723 6.3879-15.723 14.272 0 7.8844 7.041 14.272 15.723 14.272 8.6822 0 15.723-6.3879 15.723-14.272 0-7.8844-7.041-14.272-15.723-14.272zm0.4394 3.0807c6.0293 0 10.909 4.8369 10.909 10.803 0 5.9666-4.8795 10.803-10.909 10.803-6.0293 0-10.918-4.8368-10.918-10.803 0-5.9666 4.8891-10.803 10.918-10.803z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m188.57 446.66c-8.6822 0-15.723 6.3879-15.723 14.272 0 7.8844 7.041 14.272 15.723 14.272 8.6822 0 15.723-6.3879 15.723-14.272 0-7.8844-7.041-14.272-15.723-14.272zm0.4394 3.0807c6.0293 0 10.909 4.8369 10.909 10.803 0 5.9666-4.8795 10.803-10.909 10.803-6.0293 0-10.918-4.8368-10.918-10.803 0-5.9666 4.8891-10.803 10.918-10.803z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m100 489.52c-7.1045 0-12.866 5.1092-12.866 11.415 0 6.306 5.7615 11.415 12.866 11.415s12.866-5.1092 12.866-11.415c0-6.306-5.7615-11.415-12.866-11.415zm0.35955 2.464c4.9337 0 8.9265 3.8686 8.9265 8.6407s-3.9928 8.6407-8.9265 8.6407-8.9344-3.8686-8.9344-8.6407 4.0007-8.6407 8.9344-8.6407z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m228.57 432.38c-8.6822 0-15.723 6.3879-15.723 14.272 0 7.8844 7.041 14.272 15.723 14.272 8.6822 0 15.723-6.3879 15.723-14.272 0-7.8844-7.041-14.272-15.723-14.272zm0.4394 3.0807c6.0293 0 10.909 4.8369 10.909 10.803 0 5.9666-4.8795 10.803-10.909 10.803-6.0293 0-10.918-4.8368-10.918-10.803 0-5.9666 4.8891-10.803 10.918-10.803z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m30 529.52c-6.3157 0-11.437 5.7486-11.437 12.844 0 7.0952 5.1218 12.844 11.437 12.844 6.3157 0 11.437-5.7486 11.437-12.844 0-7.0952-5.1218-12.844-11.437-12.844zm0.31963 2.7723c4.3859 0 7.9354 4.3527 7.9354 9.7221 0 5.3693-3.5495 9.722-7.9354 9.722s-7.9423-4.3527-7.9423-9.722 3.5565-9.7221 7.9423-9.7221z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m-42.857 540.95c-8.6822 0-15.723 6.3879-15.723 14.272 0 7.8844 7.041 14.272 15.723 14.272 8.6822 0 15.723-6.3879 15.723-14.272 0-7.8844-7.041-14.272-15.723-14.272zm0.4394 3.0807c6.0293 0 10.909 4.8369 10.909 10.803 0 5.9666-4.8795 10.803-10.909 10.803-6.0293 0-10.918-4.8368-10.918-10.803 0-5.9666 4.8891-10.803 10.918-10.803z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m-140 563.8c-7.1045 0-12.866 4.4698-12.866 9.9866s5.7615 9.9866 12.866 9.9866 12.866-4.4698 12.866-9.9866-5.7615-9.9866-12.866-9.9866zm0.35955 2.1556c4.9337 0 8.9265 3.3844 8.9265 7.5594 0 4.1749-3.9928 7.5593-8.9265 7.5593s-8.9344-3.3844-8.9344-7.5593 4.0007-7.5594 8.9344-7.5594z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m-222.86 586.66c-8.6822 0-15.723 6.3879-15.723 14.272 0 7.8844 7.041 14.272 15.723 14.272 8.6822 0 15.723-6.3879 15.723-14.272 0-7.8844-7.041-14.272-15.723-14.272zm0.4394 3.0807c6.0293 0 10.909 4.8369 10.909 10.803 0 5.9666-4.8795 10.803-10.909 10.803-6.0293 0-10.918-4.8368-10.918-10.803 0-5.9666 4.8891-10.803 10.918-10.803z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m691.43 500.95c-8.6822 0-15.723 6.3879-15.723 14.272 0 7.8844 7.041 14.272 15.723 14.272 8.6822 0 15.723-6.3879 15.723-14.272 0-7.8844-7.041-14.272-15.723-14.272zm0.4394 3.0807c6.0293 0 10.909 4.8369 10.909 10.803 0 5.9666-4.8795 10.803-10.909 10.803-6.0293 0-10.918-4.8368-10.918-10.803 0-5.9666 4.8891-10.803 10.918-10.803z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m725.71 558.09c-8.6822 0-15.723 6.3879-15.723 14.272 0 7.8844 7.041 14.272 15.723 14.272 8.6822 0 15.723-6.3879 15.723-14.272 0-7.8844-7.041-14.272-15.723-14.272zm0.4394 3.0807c6.0293 0 10.909 4.8369 10.909 10.803 0 5.9666-4.8795 10.803-10.909 10.803-6.0293 0-10.918-4.8368-10.918-10.803 0-5.9666 4.8891-10.803 10.918-10.803z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m-128.57 200.95c-8.6822 0-15.723 6.3879-15.723 14.272 0 7.8844 7.041 14.272 15.723 14.272 8.6822 0 15.723-6.3879 15.723-14.272 0-7.8844-7.041-14.272-15.723-14.272zm0.4394 3.0807c6.0293 0 10.909 4.8369 10.909 10.803 0 5.9666-4.8795 10.803-10.909 10.803-6.0293 0-10.918-4.8368-10.918-10.803 0-5.9666 4.8891-10.803 10.918-10.803z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m962.86 655.23c-8.6822 0-15.723 6.3879-15.723 14.272 0 7.8844 7.041 14.272 15.723 14.272 8.6822 0 15.723-6.3879 15.723-14.272 0-7.8844-7.041-14.272-15.723-14.272zm0.4394 3.0807c6.0293 0 10.909 4.8369 10.909 10.803 0 5.9666-4.8795 10.803-10.909 10.803-6.0293 0-10.918-4.8368-10.918-10.803 0-5.9666 4.8891-10.803 10.918-10.803z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m1014.3 660.95c-8.6822 0-15.723 6.3879-15.723 14.272 0 7.8844 7.041 14.272 15.723 14.272 8.6822 0 15.723-6.3879 15.723-14.272 0-7.8844-7.041-14.272-15.723-14.272zm0.4394 3.0807c6.0293 0 10.909 4.8369 10.909 10.803 0 5.9666-4.8795 10.803-10.909 10.803-6.0293 0-10.918-4.8368-10.918-10.803 0-5.9666 4.8891-10.803 10.918-10.803z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m1060 658.09c-8.6822 0-15.723 6.3879-15.723 14.272 0 7.8844 7.041 14.272 15.723 14.272 8.6822 0 15.723-6.3879 15.723-14.272 0-7.8844-7.041-14.272-15.723-14.272zm0.4394 3.0807c6.0293 0 10.909 4.8369 10.909 10.803 0 5.9666-4.8795 10.803-10.909 10.803-6.0293 0-10.918-4.8368-10.918-10.803 0-5.9666 4.8891-10.803 10.918-10.803z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m1091.4 675.23c-5.5268 0-10.009 4.4698-10.009 9.9866s4.4821 9.9866 10.009 9.9866c5.5268 0 10.009-4.4698 10.009-9.9866s-4.4821-9.9866-10.009-9.9866zm0.2797 2.1556c3.8381 0 6.9442 3.3844 6.9442 7.5594 0 4.1749-3.1061 7.5593-6.9442 7.5593-3.838 0-6.9503-3.3844-6.9503-7.5593s3.1123-7.5594 6.9503-7.5594z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m-82.857 550.95c-7.1045 0-12.866 4.4698-12.866 9.9866s5.7615 9.9866 12.866 9.9866 12.866-4.4698 12.866-9.9866-5.7615-9.9866-12.866-9.9866zm0.35955 2.1556c4.9337 0 8.9265 3.3844 8.9265 7.5594 0 4.1749-3.9928 7.5593-8.9265 7.5593s-8.9344-3.3844-8.9344-7.5593 4.0007-7.5594 8.9344-7.5594z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m-191.43 556.66c-7.1045 0-12.866 4.4698-12.866 9.9866s5.7615 9.9866 12.866 9.9866 12.866-4.4698 12.866-9.9866-5.7615-9.9866-12.866-9.9866zm0.35955 2.1556c4.9337 0 8.9265 3.3844 8.9265 7.5594 0 4.1749-3.9928 7.5593-8.9265 7.5593s-8.9344-3.3844-8.9344-7.5593 4.0007-7.5594 8.9344-7.5594z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m-111.43 550.95c-7.1045 0-12.866 4.4698-12.866 9.9866s5.7615 9.9866 12.866 9.9866 12.866-4.4698 12.866-9.9866-5.7615-9.9866-12.866-9.9866zm0.35955 2.1556c4.9337 0 8.9265 3.3844 8.9265 7.5594 0 4.1749-3.9928 7.5593-8.9265 7.5593s-8.9344-3.3844-8.9344-7.5593 4.0007-7.5594 8.9344-7.5594z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m65.714 499.52c-7.1045 0-12.866 4.4698-12.866 9.9866s5.7615 9.9866 12.866 9.9866 12.866-4.4698 12.866-9.9866-5.7615-9.9866-12.866-9.9866zm0.35955 2.1556c4.9337 0 8.9265 3.3844 8.9265 7.5594 0 4.1749-3.9928 7.5593-8.9265 7.5593s-8.9344-3.3844-8.9344-7.5593 4.0007-7.5594 8.9344-7.5594z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m154.29 473.8c-7.1045 0-12.866 4.4698-12.866 9.9866s5.7615 9.9866 12.866 9.9866 12.866-4.4698 12.866-9.9866-5.7615-9.9866-12.866-9.9866zm0.35955 2.1556c4.9337 0 8.9265 3.3844 8.9265 7.5594 0 4.1749-3.9928 7.5593-8.9265 7.5593s-8.9344-3.3844-8.9344-7.5593 4.0007-7.5594 8.9344-7.5594z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m-5.7143 539.52c-7.1045 0-12.866 4.4698-12.866 9.9866s5.7615 9.9866 12.866 9.9866 12.866-4.4698 12.866-9.9866-5.7615-9.9866-12.866-9.9866zm0.35955 2.1556c4.9337 0 8.9265 3.3844 8.9265 7.5594 0 4.1749-3.9928 7.5593-8.9265 7.5593s-8.9344-3.3844-8.9344-7.5593 4.0007-7.5594 8.9344-7.5594z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m291.43 399.52c-7.1045 0-12.866 4.4698-12.866 9.9866s5.7615 9.9866 12.866 9.9866 12.866-4.4698 12.866-9.9866-5.7615-9.9866-12.866-9.9866zm0.35955 2.1556c4.9337 0 8.9265 3.3844 8.9265 7.5594 0 4.1749-3.9928 7.5593-8.9265 7.5593s-8.9344-3.3844-8.9344-7.5593 4.0007-7.5594 8.9344-7.5594z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m291.43 499.52c-7.1045 0-12.866 4.4698-12.866 9.9866s5.7615 9.9866 12.866 9.9866 12.866-4.4698 12.866-9.9866-5.7615-9.9866-12.866-9.9866zm0.35955 2.1556c4.9337 0 8.9265 3.3844 8.9265 7.5594 0 4.1749-3.9928 7.5593-8.9265 7.5593s-8.9344-3.3844-8.9344-7.5593 4.0007-7.5594 8.9344-7.5594z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m285.71 548.09c-7.1045 0-12.866 4.4698-12.866 9.9866s5.7615 9.9866 12.866 9.9866 12.866-4.4698 12.866-9.9866-5.7615-9.9866-12.866-9.9866zm0.35955 2.1556c4.9337 0 8.9265 3.3844 8.9265 7.5594 0 4.1749-3.9928 7.5593-8.9265 7.5593s-8.9344-3.3844-8.9344-7.5593 4.0007-7.5594 8.9344-7.5594z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m317.14 656.66c-7.1045 0-12.866 4.4698-12.866 9.9866s5.7615 9.9866 12.866 9.9866 12.866-4.4698 12.866-9.9866-5.7615-9.9866-12.866-9.9866zm0.35955 2.1556c4.9337 0 8.9265 3.3844 8.9265 7.5594 0 4.1749-3.9928 7.5593-8.9265 7.5593s-8.9344-3.3844-8.9344-7.5593 4.0007-7.5594 8.9344-7.5594z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m325.71 688.09c-7.1045 0-12.866 4.4698-12.866 9.9866s5.7615 9.9866 12.866 9.9866 12.866-4.4698 12.866-9.9866-5.7615-9.9866-12.866-9.9866zm0.35955 2.1556c4.9337 0 8.9265 3.3844 8.9265 7.5594 0 4.1749-3.9928 7.5593-8.9265 7.5593s-8.9344-3.3844-8.9344-7.5593 4.0007-7.5594 8.9344-7.5594z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m148.57 219.52c-7.1045 0-12.866 4.4698-12.866 9.9866s5.7615 9.9866 12.866 9.9866 12.866-4.4698 12.866-9.9866-5.7615-9.9866-12.866-9.9866zm0.35955 2.1556c4.9337 0 8.9265 3.3844 8.9265 7.5594 0 4.1749-3.9928 7.5593-8.9265 7.5593s-8.9344-3.3844-8.9344-7.5593 4.0007-7.5594 8.9344-7.5594z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m100 233.8c-7.1045 0-12.866 4.4698-12.866 9.9866s5.7615 9.9866 12.866 9.9866 12.866-4.4698 12.866-9.9866-5.7615-9.9866-12.866-9.9866zm0.35955 2.1556c4.9337 0 8.9265 3.3844 8.9265 7.5594 0 4.1749-3.9928 7.5593-8.9265 7.5593s-8.9344-3.3844-8.9344-7.5593 4.0007-7.5594 8.9344-7.5594z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m68.571 268.09c-7.1045 0-12.866 4.4698-12.866 9.9866s5.7615 9.9866 12.866 9.9866 12.866-4.4698 12.866-9.9866-5.7615-9.9866-12.866-9.9866zm0.35955 2.1556c4.9337 0 8.9265 3.3844 8.9265 7.5594 0 4.1749-3.9928 7.5593-8.9265 7.5593s-8.9344-3.3844-8.9344-7.5593 4.0007-7.5594 8.9344-7.5594z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m354.29 279.52c-7.1045 0-12.866 4.4698-12.866 9.9866s5.7615 9.9866 12.866 9.9866 12.866-4.4698 12.866-9.9866-5.7615-9.9866-12.866-9.9866zm0.35955 2.1556c4.9337 0 8.9265 3.3844 8.9265 7.5594 0 4.1749-3.9928 7.5593-8.9265 7.5593s-8.9344-3.3844-8.9344-7.5593 4.0007-7.5594 8.9344-7.5594z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m405.71 270.38c-7.1045 0-12.866 4.4698-12.866 9.9866s5.7615 9.9866 12.866 9.9866 12.866-4.4698 12.866-9.9866-5.7615-9.9866-12.866-9.9866zm0.35955 2.1556c4.9337 0 8.9265 3.3844 8.9265 7.5594 0 4.1749-3.9928 7.5593-8.9265 7.5593s-8.9344-3.3844-8.9344-7.5593 4.0007-7.5594 8.9344-7.5594z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m1188.5-388.92c-179.72-116.67-450.87-116.16-582.84 78.425 159.77-56.73 392.61-90.295 582.84-78.425z",
    fill: "#ff8080",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m-288.57-53.339c-6.3157 0-11.437 4.4698-11.437 9.9866 0 5.5169 5.1218 9.9866 11.437 9.9866 6.3157 0 11.437-4.4698 11.437-9.9866s-5.1218-9.9866-11.437-9.9866zm0.31963 2.1556c4.3859 0 7.9354 3.3844 7.9354 7.5594 0 4.1749-3.5495 7.5593-7.9354 7.5593s-7.9424-3.3844-7.9424-7.5593 3.5565-7.5594 7.9424-7.5594z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m-260-114.77c-6.3157 0-11.437 4.4698-11.437 9.9866 0 5.5169 5.1218 9.9866 11.437 9.9866 6.3157 0 11.437-4.4698 11.437-9.9866s-5.1218-9.9866-11.437-9.9866zm0.31963 2.1556c4.3859 0 7.9354 3.3844 7.9354 7.5594 0 4.1749-3.5495 7.5594-7.9354 7.5594s-7.9424-3.3844-7.9424-7.5594c0-4.1749 3.5565-7.5594 7.9424-7.5594z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m-297.14 8.0899c-6.3157 0-11.437 4.4698-11.437 9.9866 0 5.5169 5.1218 9.9866 11.437 9.9866 6.3157 0 11.437-4.4698 11.437-9.9866s-5.1218-9.9866-11.437-9.9866zm0.31963 2.1556c4.3859 0 7.9354 3.3844 7.9354 7.5594 0 4.1749-3.5495 7.5593-7.9354 7.5593s-7.9424-3.3844-7.9424-7.5593 3.5565-7.5594 7.9424-7.5594z",
    fill: "#ffd5d5",
    fillRule: "evenodd",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.23338 0 0 .23338 150.73 134.69)",
    d: "m674.29 203.79c23.78 7.2125 47.45-9.947 71.23-2.727 54.895 21.779 42.268 103.92-0.94672 179.1-17.234 33.832-31.419 69.536-53.834 100.45-4.1774 18.203-25.576-8.829-7.9899-11.971 52.792-110.77 146.66-254.05 0.0703-260.4-3.0122-1.1222-5.9264-2.5582-8.5296-4.4568l-8e-5 0.0048z",
    fill: "#ff2a2a",
    label: "Layer3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.47295 .31617 -.31617 .47295 304.65 -69.415)",
    d: "m240.9 363.85c0 19.718-15.985 35.703-35.703 35.703s-35.703-15.985-35.703-35.703 15.985-35.703 35.703-35.703 35.703 15.985 35.703 35.703z",
    fill: "#fff",
    stroke: "#000",
    strokeOpacity: 0.61497,
    strokeWidth: 5.7,
    label: "Capa 1"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.47295 .31617 -.31617 .47295 304.65 -69.415)",
    d: "m336.73 363.85c0 19.718-15.985 35.703-35.703 35.703s-35.703-15.985-35.703-35.703 15.985-35.703 35.703-35.703 35.703 15.985 35.703 35.703z",
    fill: "#fff",
    stroke: "url(#f)",
    strokeOpacity: 0.61497,
    strokeWidth: 5.7,
    label: "Capa 1"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.4798 .32076 -.32076 .4798 275.47 -48.626)",
    d: "m244.29 306.54c0 6.7458-5.8051 12.214-12.966 12.214s-12.966-5.4685-12.966-12.214 5.805-12.214 12.966-12.214 12.966 5.4685 12.966 12.214z",
    opacity: 0.83857,
    label: "Capa 1"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.4798 .32076 -.32076 .4798 320.96 -18.211)",
    d: "m244.29 306.54c0 6.7458-5.8051 12.214-12.966 12.214s-12.966-5.4685-12.966-12.214 5.805-12.214 12.966-12.214 12.966 5.4685 12.966 12.214z",
    opacity: 0.83857,
    label: "Capa 1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOctopus);
export default __webpack_public_path__ + "static/media/octopus.3da65bd09e9889ac51d829aad41c2654.svg";
export { ForwardRef as ReactComponent };